// WCC Projects > Change of Routine
// src > ts > settings.ts
// Created 11 July 2024, Updated 31 October 2024 (Version 3.0.5)

// MODULES

import * as app from './app';
import firebase from 'firebase/app';

// TYPES

import { Organisation, UserGroup, UserData, FormTemplate, ProcessTemplate, ProcessTemplateType } from './model';

// VARIABLES

let organisationData: Organisation;
let organisationUserGroups: { [groupId: string]: UserGroup } = {};
let organisationFormTemplates: { [templateId: string]: FormTemplate } = {};
let changesHaveSaved = true;

// FUNCTIONS

const main = () => {
  jQuery(setDocumentListeners);
  Promise.all([getOrganisationData(), getUser()]).then(promiseResults => {
    const user = promiseResults[1];
    layoutUserSpecificPermissions(user.email!);
    layoutPeople();
    layoutGroups();
    $('#settings-container').show();
    $('#loading').hide();
  }).catch(error => {
    if (error === 'No user signed in') {
      document.location.href = './signin.html';
    }
    console.error(error);
  });
};

const setDocumentListeners = () => {
  $('#settings-container .segmented-control li').on('click', segmentedControlClicked);
  $('.popup').on('click', didClickOutPopup);
  $('#unsaved-changes-popup .button.primary, #saving-error-popup .button.primary, #csv-error-popup .button.primary').on('click', hideAllPopups);
  $('#users-menu-section').on('click', 'li', didClickUsersMenuItem);
  $('#groups-menu-section').on('click', 'li', didClickGroupMenuItem);
  $('#templates-menu-section').on('click', 'li', didClickTemplateMenuItem);
  $('#settings-container .content-container').on('change', 'select', didChangeValue);
  $('#settings-container .content-container, #users-preview-table-body').on('keydown', 'input', didChangeValue);
  $('.users-content-section .actions-container .button.primary').on('click', saveUsers);
  $('.template-content-section .actions-container .button.primary').on('click', saveTemplate);
  $('#process-csv-file').on('click', processCsvFile);
  $('#users-overview-upload').on('click', () => {
    $('#users-overview-container').hide();
    $('#users-upload-container').show();
  });
  $('#users-upload-back').on('click', () => {
    $('#users-overview-container').show();
    $('#users-upload-container').hide();
  });
  $('#users-overview-export').on('click', exportUsers);
  $('#add-user').on('click', addUser);
};

const disableApp = () => {
  const $homeButton = $('#overview-container .button');
  $homeButton.attr('href', '');
  $homeButton.addClass('disabled');
};

const enableApp = () => {
  const $homeButton = $('#overview-container .button');
  $homeButton.attr('href', './index.html');
  $homeButton.addClass('disabled');
};

const didClickOutPopup = (event: Event) => {
  if (event.target && !$(event.target).hasClass('error-popup') && $(event.target).closest('.popup-container').length === 0) {
    hideAllPopups();
  }
};

const hideAllPopups = () => {
  $('.popup').hide();
};

const segmentedControlClicked = (event: Event) => {
  const $li = $(event.currentTarget!);
  $li.siblings().removeClass('selected');
  $li.addClass('selected');
  $('.settings-menu').hide();
  if ($li.attr('id') === 'general-option') {
    $('#general-menu').show();
    $('.menu-container h3').text('General Settings');
  } else if ($li.attr('id') === 'people-option') {
    $('#people-menu').show();
    $('.menu-container h3').text('People and Groups');
  } else if ($li.attr('id') === 'forms-option') {
    $('#forms-menu').show();
    $('.menu-container h3').text('Form Templates');
  }
};

const getOrganisationData = async (): Promise<void> => {
  const organisationPromise = app.database().collection('organisations').doc('i7CJzk2FBN6sfax4TXs5').get();
  const groupsPromise = app.database().collection('organisations').doc('i7CJzk2FBN6sfax4TXs5').collection('groups').get();
  const templatesPromise = app.database().collection('organisations').doc('i7CJzk2FBN6sfax4TXs5').collection('templates').get();
  const [organisationSnapshot, groupsSnapshot, templatesSnapshot] = await Promise.all([organisationPromise, groupsPromise, templatesPromise]);

  const organisationSnapshotData = organisationSnapshot.data();
  if (!organisationSnapshot.exists || !organisationSnapshotData) {
    throw new Error("Organisation doesn't exist");
  }
  organisationData = organisationSnapshotData as Organisation;
  organisationData.usersData.sort((a, b) => {
    return a.fullName < b.fullName ? -1 : 1;
  });

  groupsSnapshot.forEach(document => {
    const groupData = document.data() as UserGroup;
    if (document.exists && groupData) {
      organisationUserGroups[document.id] = groupData;
    }
  });

  templatesSnapshot.forEach(document => {
    const templateData = document.data() as FormTemplate;
    if (document.exists && templateData) {
      organisationFormTemplates[document.id] = templateData;
    }
  });
};

const nameForEmail = (email: string): string => {
  return organisationData.usersData.find(organisationUser => organisationUser.email === email)?.fullName ?? email.split('@')[0];
};

const timestampToDate = (timestamp: any): Date => {
  return (timestamp as unknown as firebase.firestore.Timestamp).toDate();
};

const shortDateString = (date: Date) => {
  const day = date.getDate().toString();
  const month = date.toLocaleString('default', { month: 'short' });
  const year = date.getFullYear().toString();
  return `${day} ${month} ${year}`;
};

const getUser = async (): Promise<firebase.User> => {
  return await new Promise((resolve, reject) => {
    app.authentication().onAuthStateChanged(user => {
      if (user == null)
        reject('No user signed in');
      else
        resolve(user);
    });
  });
};

const layoutUserSpecificPermissions = (email: string) => {
  if (email.includes('agebran2') || email.includes('jzhou2') || email.includes('akaia') || email.includes('mrefalo4') || email.includes('dgrigson')) {
    return;
  }
  $('#no-permissions-popup').show();
};

const layoutPeople = () => {
  $('#users-menu-section #all-users .caption').text(countPeopleToText(organisationData.usersData));
  let usersPreviewRows = '';
  for (const userData of organisationData.usersData) {
    usersPreviewRows += /* html */`<tr>
      <td><input type="text" class="email" value="${userData.email ?? ''}"></td>
      <td><input type="text" class="full-name" value="${userData.fullName ?? ''}"></td>
      <td><input type="text" class="role" value="${userData.role ?? ''}"></td>
      <td>
        <span class="archive">Archive</span>
      </td>
    <tr>`;
  }
  $('#users-preview-table-body').html(usersPreviewRows);
};

const layoutGroups = () => {
  let groupsMenuSection = '';
  let contentSections = '';
  for (const [groupId, groupData] of Object.entries(organisationUserGroups)) {
    groupData.members.sort();
    groupsMenuSection += /* html */`
      <li id="group-${groupId}">
        <div class="title">${groupData.title}</div>
        <div class="caption">${countPeopleToText(groupData.members)}</div>
      </li>
    `;
    let membersHtml = '';
    for (const userEmail of groupData.members) {
      membersHtml += /* html */`<div class="member">
        ${htmlForUsersSelect(organisationData.usersData, userEmail)}
        <span class="remove">Remove</span>
      </div>`;
    }
    contentSections += /* html */`
      <div id="group-${groupId}" class="content-section group-content-section" style="display: none;">
        <div class="content-section-header">
          <div class="text-container">
            <h3>Edit Group</h3>
            <p>Changes only apply to new forms. Existing forms will be unaffected.</p>
          </div>
          <div class="actions-container" style="display: none;">
            <a class="button primary">Save</a>
            <a class="button secondary cancel" href="./settings.html">Cancel</a>
          </div>
        </div>
        <div class="content-section-main">
          <label for="group-title">Group Name</label>
          <input type="text" id="group-title" name="group-title" placeholder="E.g. 'Valid Form Approvers'"${groupData.title ? ` value="${groupData.title}"` : ''}>
          <label>Group Members</label>
          <div class="group-members">
            ${membersHtml}
            <span id="add-member">Add group member</span>
          </div>
        </div>
      </div>
    `;
  }
  $('#groups-menu-section').append(groupsMenuSection);
  $('#settings-container .content-container').append(contentSections);
  $('.group-content-section .actions-container .button.primary').on('click', saveGroup);
  $('#users-preview-table-body').on('click', '.archive', archiveUser);
  $('.group-content-section').on('click', '.member .remove', removeGroupMember);
  $('.group-content-section').on('click', '#add-member', addGroupMember);
};

const archiveUser = (event: JQuery.ClickEvent<HTMLElement>) => {
  didChangeValue(event);
  $(event.target).parent().parent().remove();
};

const removeGroupMember = (event: JQuery.ClickEvent<HTMLElement>) => {
  didChangeValue(event);
  $(event.target).parent().remove();
};

const addGroupMember = (event: JQuery.ClickEvent<HTMLElement>) => {
  didChangeValue(event);
  $(event.target).before(/* html */`<div class="member">
    ${htmlForUsersSelect(organisationData.usersData)}
    <span class="remove">Remove</span>
  </div>`);
};

const addUser = (event: JQuery.ClickEvent<HTMLElement>) => {
  didChangeValue(event);
  $('#users-preview-table-body').append(/* html */`<tr>
    <td><input type="text" class="email"></td>
    <td><input type="text" class="full-name"></td>
    <td><input type="text" class="role"></td>
    <td>
      <span class="archive">Archive</span>
    </td>
  <tr>`);
};

const updateUsersDataFromTable = () => {
  organisationData.usersData = [];
  $('#users-preview-table-body').find('tr').each((index, userRow) => {
    const $userRow = $(userRow);
    const $email = $userRow.find('.email');
    const $fullName = $userRow.find('.full-name');
    const $role = $userRow.find('.role');
    if ($email.length && $fullName.length && $role.length) {
      const email = ($email.val() as string).trim().toLowerCase();;
      const fullName = ($fullName.val() as string).trim();
      let role = ($role.val() as string).trim();
      if (['-', '–', 'na', 'n/a', 'none', 'blank', 'false'].includes(role.toLowerCase())) {
        role = '';
      }
      if (email && emailIsValid(email) && fullName && fullName.length > 2) {
        let user: UserData = {
          email: email,
          fullName: fullName,
        };
        if (role) {
          user.role = role;
        }
        organisationData.usersData.push(user);
      }
    }
  });
};

const saveUsers = (event: JQuery.ClickEvent<HTMLElement>) => {
  const $saveButton = $(event.currentTarget);
  const $usersContentSection = $saveButton.closest('.users-content-section');
  showButtonLoading($saveButton);
  updateUsersDataFromTable();
  app.database().collection('organisations').doc('i7CJzk2FBN6sfax4TXs5').update({
    usersData: organisationData.usersData
  }).then(() => {
    changesHaveSaved = true;
    hideButtonLoading($saveButton);
    $usersContentSection.find('.actions-container').hide();
    window.location.reload();
  }).catch(error => {
    console.error(error);
    hideButtonLoading($saveButton);
    $('#saving-error-popup').show();
  });
};

const saveGroup = (event: JQuery.ClickEvent<HTMLElement>) => {
  const $saveButton = $(event.currentTarget);
  const $groupContentSection = $saveButton.closest('.group-content-section');
  const groupId = $groupContentSection.attr('id')?.replace('group-', '');
  if (groupId) {
    showButtonLoading($saveButton);
    const members: string[] = [];
    $groupContentSection.find('.group-members select').each((index, selectElement) => {
      const email = ($(selectElement).val() as string).trim();
      if (email && email != 'null' && emailIsValid(email)) {
        members.push(email);
      }
    });
    const groupData: UserGroup = {
      title: $groupContentSection.find('#group-title').val() as string,
      members: members,
    };
    app.database().collection('organisations').doc('i7CJzk2FBN6sfax4TXs5').collection('groups').doc(groupId).update(groupData).then(() => {
      changesHaveSaved = true;
      hideButtonLoading($saveButton);
      $groupContentSection.find('.actions-container').hide();
      window.location.reload();
    }).catch(error => {
      console.error(error);
      hideButtonLoading($saveButton);
      $('#saving-error-popup').show();
    });
  }
};

const saveTemplate = (event: JQuery.ClickEvent<HTMLElement>) => {
  const $saveButton = $(event.currentTarget);
  const $templateContentSection = $saveButton.closest('.template-content-section');
  const templateId = $templateContentSection.attr('id')?.replace('template-', '');
  if (templateId) {
    showButtonLoading($saveButton);
    const processData: ProcessTemplate[] = [];
    processData.push({
      type: ProcessTemplateType.group1,
      approvers: [
        $templateContentSection.find('#stage-1').val() as string,
      ],
    });
    if (templateId === 'tAeuhEGem3fFn3LXi1fn' || templateId === 'FbG53tCjunlAlCnpq8IK' || templateId === '2ZQOPes4rfwfwY1heNgk') {
      processData.push({
        type: ProcessTemplateType.specified2,
        approvers: [
          $templateContentSection.find('#stage-2').val() as string,
          $templateContentSection.find('#stage-3').val() as string,
        ],
      });
      processData.push({
        type: ProcessTemplateType.specified1,
        approvers: [
          $templateContentSection.find('#stage-4').val() as string,
        ],
      });
    }
    const templateData: FormTemplate = {
      title: $templateContentSection.find('#template-title').val() as string,
      createGroup: $templateContentSection.find('#creation-group').val() as string,
      archiveGroup: $templateContentSection.find('#archive-group').val() as string,
      process: processData,
    };
    app.database().collection('organisations').doc('i7CJzk2FBN6sfax4TXs5').collection('templates').doc(templateId).update(templateData).then(() => {
      changesHaveSaved = true;
      hideButtonLoading($saveButton);
      $templateContentSection.find('.actions-container').hide();
      window.location.reload();
    }).catch(error => {
      console.error(error);
      hideButtonLoading($saveButton);
      $('#saving-error-popup').show();
    });
  }
};

const didClickUsersMenuItem = (event: JQuery.ClickEvent<HTMLElement>) => {
  if (!changesHaveSaved) {
    $('#unsaved-changes-popup').show();
    return;
  }
  const id = event.currentTarget.id;
  $('.settings-menu li').removeClass('selected');
  $(event.currentTarget).addClass('selected');
  $('.content-section').hide();
  $(`.users-content-section#${id}`).show();
};

const didClickGroupMenuItem = (event: JQuery.ClickEvent<HTMLElement>) => {
  if (!changesHaveSaved) {
    $('#unsaved-changes-popup').show();
    return;
  }
  const groupId = event.currentTarget.id;
  $('.settings-menu li').removeClass('selected');
  $(event.currentTarget).addClass('selected');
  $('.content-section').hide();
  $(`.group-content-section#${groupId}`).show();
};

const didClickTemplateMenuItem = (event: JQuery.ClickEvent<HTMLElement>) => {
  if (!changesHaveSaved) {
    $('#unsaved-changes-popup').show();
    return;
  }
  const templateSectionId = event.currentTarget.id;
  $('.settings-menu li').removeClass('selected');
  $(event.currentTarget).addClass('selected');
  $('.content-section').hide();
  const $templateContentSection = $(`.template-content-section#${templateSectionId}`);
  const templateId = templateSectionId.replace('template-', '');
  const formTemplate = organisationFormTemplates[templateId];
  if (formTemplate) {
    let fieldIndex = 0;
    for (const stage of formTemplate.process) {
      fieldIndex ++;
      if (stage.type === ProcessTemplateType.group1) {
        $templateContentSection.find(`#stage-${fieldIndex}`).html(innerHtmlForGroupsSelect(organisationUserGroups, stage.approvers[0]));
      } else if (stage.type === ProcessTemplateType.specified1) {
        $templateContentSection.find(`#stage-${fieldIndex}`).html(innerHtmlForUsersSelect(organisationData.usersData, stage.approvers[0]));
      } else if (stage.type === ProcessTemplateType.specified2) {
        $templateContentSection.find(`#stage-${fieldIndex}`).html(innerHtmlForUsersSelect(organisationData.usersData, stage.approvers[0]));
        $templateContentSection.find(`#stage-${fieldIndex + 1}`).html(innerHtmlForUsersSelect(organisationData.usersData, stage.approvers[1]));
        fieldIndex ++;
      }
    }
    $templateContentSection.find('#archive-group').html(innerHtmlForGroupsSelect(organisationUserGroups, formTemplate.archiveGroup));
  }
  $templateContentSection.show();
};

const didChangeValue = (event: (JQuery.ChangeEvent<HTMLElement> | JQuery.KeyDownEvent<HTMLElement> | JQuery.ClickEvent<HTMLElement>)) => {
  if (changesHaveSaved) {
    changesHaveSaved = false;
    const $changedElement = $(event.currentTarget);
    const $contentSection = $changedElement.closest('.content-section');
    $contentSection.find('.actions-container').show();
  }
};

const countPeopleToText = (people: any[]): string => {
  return `${people.length} ${people.length === 1 ? 'person' : 'people'}`;
};

const htmlForUsersSelect = (users: UserData[], selectedEmail?: string): string => {
  return `<select>
    ${(innerHtmlForUsersSelect(users, selectedEmail))}
  </select>`;
};

const innerHtmlForUsersSelect = (users: UserData[], selectedEmail?: string): string => {
  let optionsHtml = '';
  let hasSelectedOption = false;
  for (const user of users) {
    const shouldSelectUser = user.email === selectedEmail;
    if (shouldSelectUser) {
      hasSelectedOption = true;
    }
    optionsHtml += /* html */`<option value="${user.email}"${shouldSelectUser ? ' selected' : ''}>${user.fullName}${user.role ? ` (${user.role})` : ''}</option>`;
  }
  if (selectedEmail && !hasSelectedOption) {
    // The user that should have been selected wasn't available, add them
    optionsHtml += /* html */`<option value="${selectedEmail}" selected>${selectedEmail}</option>`;
    hasSelectedOption = true;
  }
  return `
    ${hasSelectedOption ? '' : '<option value="null" disabled selected>Select</option>'}
    ${optionsHtml}
  `;
};

const htmlForSelectWithGroups = (groups: { [groupId: string]: UserGroup }, selectedGroupId?: string): string => {
  return `<select>
    ${innerHtmlForGroupsSelect(groups, selectedGroupId)}
  </select>`;
};

const innerHtmlForGroupsSelect = (groups: { [groupId: string]: UserGroup }, selectedGroupId?: string): string => {
  let optionsHtml = '';
  let hasSelectedOption = false;
  for (const [groupId, groupData] of Object.entries(groups)) {
    const shouldSelectGroup = groupId === selectedGroupId;
    if (shouldSelectGroup) {
      hasSelectedOption = true;
    }
    optionsHtml += /* html */`<option value="${groupId}"${shouldSelectGroup ? ' selected' : ''}>${groupData.title} (${countPeopleToText(groupData.members)})</option>`;
  }
  if (selectedGroupId && !hasSelectedOption) {
    // The group that should have been selected wasn't available, add them
    optionsHtml += /* html */`<option value="${selectedGroupId}" selected>Group ${selectedGroupId}</option>`;
    hasSelectedOption = true;
  }
  return `
    ${hasSelectedOption ? '' : '<option value="null" disabled selected>Select</option>'}
    ${optionsHtml}
  `;
};

const showButtonLoading = ($button: JQuery<HTMLElement>) => {
  $button.find('.button-text').hide();
  $button.find('.button-loading').show();
};

const hideButtonLoading = ($button: JQuery<HTMLElement>) => {
  $button.find('.button-text').show();
  $button.find('.button-loading').hide();
};

const emailIsValid = (email: any) => {
  return typeof email === "string" && email.includes("parra.catholic.edu.au");
};

const processCsvFile = (event: JQuery.ClickEvent<HTMLElement>) => {
  const fileInput = document.getElementById('users-upload') as HTMLInputElement;
  const file = fileInput.files?.[0];
  if (file && file.name.endsWith('.csv')) {
    const reader = new FileReader();
    reader.onload = (event) => {
      const fileContent = event.target!.result as string;
      const lines = fileContent.split('\n');
      const header = lines[0].trim().toLowerCase();
      const columnOptions = header.split(',');
      if (columnOptions.length < 2 || !columnOptions.includes('full name') || !columnOptions.includes('email')) {
        $('#csv-error-popup').show();
      } else {
        const uploadNewUsers = $('#upload-new-users-checkbox').is(':checked');
        const updateExistingUsers = $('#update-existing-users-checkbox').is(':checked');
        const deleteExistingUsers = $('#delete-existing-users-checkbox').is(':checked');
        if (deleteExistingUsers) {
          organisationData.usersData = [];
        }
        console.log(columnOptions);
        for (let index = 1; index < lines.length; index ++) {
          console.log(index);
          const lineCells = lines[index].split(',');
          const email = (lineCells[columnOptions.indexOf('email')] ?? '').replace(/"/g, '').trim().toLowerCase();
          const fullName = (lineCells[columnOptions.indexOf('full name')] ?? '').replace(/"/g, '').trim();
          const roleIndex = columnOptions.indexOf('role');
          let role = '';
          if (roleIndex !== -1) {
            role = (lineCells[roleIndex] ?? '').replace(/"/g, '').trim();
            if (['-', '–', 'na', 'n/a', 'none', 'blank', 'false'].includes(role.toLowerCase())) {
              role = '';
            }
          }
          if (email && emailIsValid(email) && fullName && fullName.length > 2) {
            const userPreviouslyExisted = organisationData.usersData.find(user => user.email === email) !== undefined;
            if (
              (uploadNewUsers && !userPreviouslyExisted) ||
              (updateExistingUsers && userPreviouslyExisted)
            ) {
              let user: UserData = {
                email: email,
                fullName: fullName,
              };
              if (role) {
                user.role = role;
              }
              if (userPreviouslyExisted) {
                for (let index = 0; index < organisationData.usersData.length; index ++) {
                  if (organisationData.usersData[index].email === email) {
                    organisationData.usersData[index] = user;
                    break;
                  }
                }
              } else {
                organisationData.usersData.push(user);
              }
            }
          }
        }
        layoutPeople();
        $('#users-overview-container').show();
        $('#users-upload-container').hide();
      }
    };
    reader.readAsText(file);
    didChangeValue(event);
  } else {
    $('#csv-error-popup').show();
  }
};

let exporting = false
const exportUsers = () => {
  console.log(exporting);
  if (!exporting) {
    exporting = true;
    updateUsersDataFromTable();
    let csvContent = 'Email,Full Name,Role\n';
    for (const userData of organisationData.usersData) {
      csvContent += csvCleanString(userData.email ?? '') + ',';
      csvContent += csvCleanString(userData.fullName ?? '') + ',';
      csvContent += csvCleanString(userData.role ?? '') + '\n';
    }
    const fileName = `staff_export_${getCurrentDateNumber()}.csv`;
    downloadCsvFile(fileName, csvContent);
    setTimeout(() => {
      exporting = false;
    }, 1000);
  }
};

const downloadCsvFile = (filename: string, content: string): void => {
  const blob = new Blob([content], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const a = $('<a></a>').attr({
      href: url,
      download: filename
  }).appendTo('body');
  a[0].click();
  a.remove();
  URL.revokeObjectURL(url);
};

const csvCleanString = (text: (string | number)): string => {
  text = `${text}`;
  if (text.includes(',')) {
    // Cells can't contain commas so enclose with double quotes
    // Any existing double quotes are now two double quotes
    text = `"${text.replace(/"/g, '""')}"`;
  }
  return text;
};

const getCurrentDateNumber = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = ('0' + (now.getMonth() + 1)).slice(-2);
  const day = ('0' + now.getDate()).slice(-2);
  const hours = ('0' + now.getHours()).slice(-2);
  const minutes = ('0' + now.getMinutes()).slice(-2);
  const seconds = ('0' + now.getSeconds()).slice(-2);
  const dateTimeNumber = Number(`${year}${month}${day}${hours}${minutes}${seconds}`);
  return dateTimeNumber;
};

// INITIAL SCRIPTS

main();
